import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router } from '@angular/router';
import { IdentityService } from './identity.service';

@Injectable({
  providedIn: 'root'
})
export class IdentityGuard implements CanActivate, CanActivateChild{
  constructor(private identityService: IdentityService, private router: Router){}

  async canActivate(): Promise<boolean>{
    console.log("Checking user is logged in")
    try{
      await this.identityService.getIdentity();
      return true;
    } catch(err) {
      this.router.navigate(['/m/signin'])
      return false;
    }
  }

  canActivateChild(): Promise<boolean>{
    return this.canActivate();
  }
}
